// extracted by mini-css-extract-plugin
export var allEvents = "agenda-module--all-events--a1106";
export var editButtonTitle = "agenda-module--edit-button-title--e2f77";
export var eventsContainer = "agenda-module--events-container--85bb5";
export var eventsDescription = "agenda-module--events-description--206e9";
export var eventsItem = "agenda-module--events-item--69fa2";
export var eventsItemDate = "agenda-module--events-item-date--e1b81";
export var eventsItemDateFrom = "agenda-module--events-item-date-from--055a7";
export var eventsItemDateTo = "agenda-module--events-item-date-to--9d263";
export var eventsItemImg = "agenda-module--events-item-img--65c32";
export var eventsItemTaxo = "agenda-module--events-item-taxo--f4d20";
export var eventsItemTitle = "agenda-module--events-item-title--cb757";
export var listEventsContainer = "agenda-module--list-events-container--b666d";
export var listEventsTitle = "agenda-module--list-events-title--6d547";